const styles = {
  partsSectionTablet: { marginBottom: 0 },
  labelsSectionTablet: { paddingLeft: 0 },
  labelTablet: {
    display: `block`,
    marginTop: 20
  },
  redLabel: { color: `red` }
};

export default styles;
